module.exports = __webpack_public_path__ + "img/wyfsr.f7bab89a.png";